type TCompare = "="|"<>"|"<"|">"|"<="|">="|"like";

function getData(name:string,data:any|null|undefined, default_value:number|string|null = null):any|null|undefined{
  if(!data) return default_value;
  if(!name) return data ?? default_value;
  let [p1, ...pl] = name.split('.');
  if(pl){
    return getData(pl.join("."),data[p1],default_value);
  } else {
    return data[p1] ?? default_value;
  }
}

function compareData(name: string, compare:TCompare, value:string|boolean|number, data:any){
  switch(compare){
    case "=": return getData(name??"", data) === value;
    case "<>": return getData(name??"", data) !== value;
    case ">": return getData(name??"", data) > value;
    case "<": return getData(name??"", data) < value;
    case ">=": return getData(name??"", data) >= value;
    case "<=": return getData(name??"", data) <= value;
    case "like": return value.toString().indexOf(getData(name??"", data, "").toString()) !== -1;
    default: return false;
  }
}

export default class Collection{
  list: any[]|object;
  constructor(list: any[]|object){
    this.list = list;
  }

  where(name: string, compare:TCompare, value:string|boolean|number){
    let r = [];
    for (const iterator of (Array.isArray(this.list)?this.list:Object.values(this.list))) {
      if(compareData(name,compare,value,iterator)){
        r.push(iterator);
      }
    }
    return new Collection(r);
  }

  isEmpty(){
    return (Array.isArray(this.list)?this.list:Object.values(this.list)).length === 0;
  }

  map(callback: (item:any) => any): Collection{
    let r = [];
    for (const iterator of (Array.isArray(this.list)?this.list:Object.values(this.list))) {
      r.push(callback(iterator))
    }
    return new Collection(r);
  }

  sum(name?:string): number{
    let total = 0;
    for (const iterator of (Array.isArray(this.list)?this.list:Object.values(this.list))) {
      total += parseFloat(getData(name??"", iterator, 0));
    }
    return total;
  }

  pluck(name?:string): Collection{
    let r = [];
    for (const iterator of (Array.isArray(this.list)?this.list:Object.values(this.list))) {
      r.push(getData(name??"", iterator))
    }
    return new Collection(r);
  }

  max(name?:string):any{
    let r = null;
    let c = Number.MIN_SAFE_INTEGER;
    for (const iterator of (Array.isArray(this.list)?this.list:Object.values(this.list))) {
      let v = getData(name??"", iterator, 0);
      if(c < v){
        r = iterator;
      }
    }
    return r;
  }

  min(name?:string):any{
    let r = null;
    let c = Number.MAX_SAFE_INTEGER;
    for (const iterator of (Array.isArray(this.list)?this.list:Object.values(this.list))) {
      let v = getData(name??"", iterator, 0);
      if(c > v){
        r = iterator;
      }
    }
    return r;
  }

  group(name?:string): Collection{
    let r:any = {};
    for (const iterator of (Array.isArray(this.list)?this.list:Object.values(this.list))) {
      let g = getData(name??"", iterator);
      if(!r[g]){
        r[g] = [];
      }
      r[g].push(iterator);
    }
    return new Collection(r);
  }

  toArray():any[]{
    return [...(Array.isArray(this.list)?this.list:Object.values(this.list))];
  }

  toObject():any{
    return this.list;
  }

  count():number{
    return (Array.isArray(this.list)?this.list:Object.values(this.list)).length;
  }
  
  sortBy(name:string):Collection{
    let l = [...(Array.isArray(this.list)?this.list:Object.values(this.list))];
    for (let i = 0; i < l.length; i++) {
      for (let j = i+1; j < l.length; j++) {
        if(getData(name??"", l[i], 0) > getData(name??"", l[j], 0)){
          let aux = l[i];
          l[i] = l[j];
          l[j] = aux;
        }
      }
    }
    return new Collection(l);
  }

  sortByDesc(name:string):Collection{
    let l = [...(Array.isArray(this.list)?this.list:Object.values(this.list))];
    for (let i = 0; i < l.length; i++) {
      for (let j = i+1; j < l.length; j++) {
        if(getData(name??"", l[i], 0) < getData(name??"", l[j], 0)){
          let aux = l[i];
          l[i] = l[j];
          l[j] = aux;
        }
      }
    }
    return new Collection(l);
  }

  shuffle(): Collection{
    let l = [...(Array.isArray(this.list)?this.list:Object.values(this.list))];
    for (let i = 0; i < l.length; i++) {
      let j = Math.floor(Math.random() * l.length)
      let aux = l[i];
      l[i] = l[j];
      l[j] = aux;
    }
    return new Collection(l);
  }
}

export function collect(list:any[]){
  return new Collection(list);
}